import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { omitBy, isNil } from 'lodash';
import { Helper } from '@vfde-fe/ngx-lib/services/helper-utils';
import { API_URLS } from '../../common/constants/routes-config';
import { API_HEADERS, MODULE_NAMES } from '../../common/constants/defines';
import { TerminationRevocationModel } from '../../../app/models/terminationRevocation.model';
import { Store } from '@ngrx/store';
import { CustomerDetailsState } from 'src/app/redux/states/customer-details.state';
import { SetXConversationId } from 'src/app/redux/actions/customer-details.actions';
import { CustomErrorHandlerService } from '@vfde-fe/ngx-lib/services/custom-error-handler';
import { DOCUMENT } from '@angular/common';
import { PageScrollService } from 'ngx-page-scroll-core';

/** RevocationTerminationService service */
@Injectable()
/** RevocationTerminationServiceService */
export class RevocationTerminationService {
    /** captcha hashed answer */
    public captchaHashedAnswer: string;
        /** captcha hashed answer */
        public captchaAnswer: string;
    /** captcha reload */
    public captchaReload = new BehaviorSubject<boolean>(false);
    /** X-Conversation-ID */
    public XConversationID: string;

    /**
     * @param http
     * @param helper
     * @param sanitizer
     * @param store <CustomerDetailsState>
     * @param pageScrollService pageScrollService
     * @param customErrorHandlerService customErrorHandlerService
     * @param document document
     */
    public constructor (
        private http: HttpClient,
        private helper: Helper,
        private store: Store<CustomerDetailsState>,
        private customErrorHandlerService: CustomErrorHandlerService,
        public pageScrollService: PageScrollService,
        @Inject(DOCUMENT) private document: any,
    ) {
    }
    /**
     * scrollToFormontainer
     * on service fails scrolls to form
     */
       public scrollToFormContainer (offset?) {
            setTimeout(() => {
                this.pageScrollService.scroll({
                    document: this.document,
                    scrollTarget: '#formContainer',
                    scrollOffset: offset? offset: 0,
                    duration: 500,
                    speed: 500,
                    });
            }, 0);
    }
    /**
     * submit form which contains all the intended data to terminate contract
     * or revoke the hardware
     * it contains all the data from three forms regarding the
     * user address personal data and contract data
     * scrolls to formcontainer when service fails (to Top)
     * @param revocationTerminationModel
     *  @param moduleName
     * @returns X-Conversation-ID and store it in the store
     */

    public terminateContractWithHardware (params: TerminationRevocationModel ,moduleName ?: string  ) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json'
                                          , 'X-Captcha-Answer': this.captchaAnswer, 'X-Captcha-Hash': this.captchaHashedAnswer });
        const url = API_URLS.TERMINATE_CONTRACT.TERMINATE_COMTRACT_HW;
        const baseUrl = this.helper.prepareURLForDXL(headers, url, true);
        const options = { headers: baseUrl.headers};
        const payload = omitBy(params, isNil);

        return this.http.post(baseUrl.url, payload, {...options, observe: 'response'}).pipe(map(((response: any) => {
            this.XConversationID =  response.headers.get(API_HEADERS.X_CONVERSATION_ID);
            this.store.dispatch(new SetXConversationId({xConversationId: this.XConversationID}));
            const res = response.body;

            return res;
        })), catchError((error) => {

            this.captchaReload.next(error);
            const errorCode = error.error.code;
            const err =  this.customErrorHandlerService.getErrorDescription(moduleName ? moduleName : MODULE_NAMES.UM_VKD_CONTRACT_CANCELLTION, errorCode, error.error.status, true);
            this.scrollToFormContainer();

            return throwError(err);
        }));

    }
}
